// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-image-view{width:100%;height:auto;border-radius:16px;border:1px solid var(--background--spacer)}.c-image-view--not-delivered{border:1px solid #dfa51d}", ""]);
// Exports
module.exports = exports;
